import type { CohortAnnouncement } from '@efdigital/ll-xceed-v2/data/builders/xceed/messages';
import type { CoachingCoacheeCohortModel } from '@efdigital/ll-xceed-v2/routes/coaching/coachee/cohort';
import type CoacheeService from '@efdigital/ll-xceed-v2/services/coachee';
import type CohortAnnouncementsService from '@efdigital/ll-xceed-v2/services/cohort-announcements';
import { cohortShowsAnnouncements } from '@efdigital/ll-xceed-v2/utils/coaching/announcements';
import Route from '@ember/routing/route';
import { service } from '@ember/service';

export type CoachingCoacheeCohortAnnouncementsModel =
  CoachingCoacheeCohortModel & {
    announcements: CohortAnnouncement[];
  };

export default class CoachingCoacheeCohortAnnouncementsRoute extends Route<CoachingCoacheeCohortAnnouncementsModel> {
  @service declare coachee: CoacheeService;
  @service declare cohortAnnouncements: CohortAnnouncementsService;

  async model(): Promise<CoachingCoacheeCohortAnnouncementsModel> {
    const parentModel = this.modelFor(
      'coaching.coachee.cohort'
    ) as CoachingCoacheeCohortModel;

    const announcements = cohortShowsAnnouncements(parentModel.cohort.css)
      ? await this.coachee
          .getCohortAnnouncements(parentModel.program_id, parentModel.cohort_id)
          .catch(() => [])
      : [];

    return {
      ...parentModel,
      announcements,
    };
  }

  afterModel(model: CoachingCoacheeCohortAnnouncementsModel): void {
    this.cohortAnnouncements.sync(
      model.announcements,
      model.program_id,
      model.cohort_id
    );
    this.cohortAnnouncements.markAllSeen(model.program_id, model.cohort_id);
  }
}
